import styled from "styled-components";

export const ContentWrapper = styled.div`
  max-width: 1400px;
  margin: 4.8rem auto;
  padding: 0 3.2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: calc(100% - 6.4rem);
  justify-content: center;

  img {
    margin: 1.6rem 2.4rem;
  }
`;
